// 系统级 (移除 viser-vue 暂不兼容 Vue3)
// import G2 from 'viser-vue'
// 图表组件
import Chart from './Charts/Chart'
// 合成插件
import FPluginReport from './plugin/FPluginReport'
import FPluginBlock from './plugin/FPluginBlock'
import FPluginList from './plugin/FPluginList'
import FPluginListno from './plugin/FPluginListno'
import FPluginListadd from './plugin/FPluginListadd'
import FPluginSingle from './plugin/FPluginSingle'
import FPluginSingleTemplate from './plugin/FPluginSingleTemplate'
import FPluginRecord from './plugin/FPluginRecord'
import FPluginPath from './plugin/FPluginPath'
import FPluginPathRecord from './plugin/FPluginPathRecord'
import FPluginPermission from './plugin/FPluginPermission'
import FPluginPermissionrecord from './plugin/FPluginPermissionrecord'
import FPluginPermissionrecordno from './plugin/FPluginPermissionrecordno'
import FPluginPermissionSinglepage from './plugin/FPluginPermissionSinglepage'
import FPluginReportEmployee from './plugin/FPluginReportEmployee'
import FPluginTree from './plugin/FPluginTree'
import FPluginTreerq from './plugin/FPluginTreerq'
import FPluginTimeline from './plugin/FPluginTimeline'
import FPluginHome from './plugin/FPluginHome'
import FPluginTable from './plugin/FPluginTable'
import FPluginCalendar from './plugin/FPluginCalendar'
import FPluginBaList from './plugin/FPluginBaList'
import FPluginProduct from './plugin/FPluginProduct'
import FPluginTreeTab from './plugin/FPluginTreeTab'
import FPluginIndoorMap from './plugin/FPluginIndoorMap'
import FPluginIndoorMapshow from './plugin/FPluginIndoorMapshow'
import FPluginDevMap from './plugin/FPluginDevMap'
// 框架布局
import FLayout from './layout/FLayout'
// 功能组件
import FReport from './parts/FReport'
import FSearch from './parts/FSearch'
import FSearchno from './parts/FSearchno'
import FTable from './parts/FTable'
import FDetail from './parts/FDetail'
import FForm from './parts/FForm'
import FIndoorMarker from './parts/FIndoorMarker'
import FUploadImage from './parts/FUploadImage'
import FUploadImages from './parts/FUploadImages'
import FUploadFile from './parts/FUploadFile'
import FTimeline from './parts/FTimeline'
import FCardList from './parts/FCardList'
import FEsign from './parts/FEsign'
import FEsignBm from './parts/FEsignBm'
import FKstime from './parts/FKstime'
import FUploadImageBm from './parts/FUploadImageBm'
// 园区服务通用概览
import ServiceOverview from '../pages/zongbu/yuanqufuwu/components/ServiceOverview.vue'

const install = (app, opts = {}) => {
  if (install.installed) return
  // 系统级
  // app.use(G2)
  // 图表组件
  app.component('Chart', Chart)
  // 合成插件
  app.component('FPluginReport', FPluginReport)
  app.component('FPluginBlock', FPluginBlock)
  app.component('FPluginList', FPluginList)
  app.component('FPluginListno', FPluginListno)
  app.component('FPluginListadd', FPluginListadd)
  app.component('FPluginSingle', FPluginSingle)
  app.component('FPluginSingleTemplate', FPluginSingleTemplate)
  app.component('FPluginRecord', FPluginRecord)
  app.component('FPluginPath', FPluginPath)
  app.component('FPluginPathRecord', FPluginPathRecord)
  app.component('FPluginPermission', FPluginPermission)
  app.component('FPluginPermissionrecord', FPluginPermissionrecord)
  app.component('FPluginPermissionrecordno', FPluginPermissionrecordno)
  app.component('FPluginPermissionSinglepage', FPluginPermissionSinglepage)
  app.component('FPluginReportEmployee', FPluginReportEmployee)
  app.component('FPluginTree', FPluginTree)
  app.component('FPluginTreerq', FPluginTreerq)
  app.component('FPluginTimeline', FPluginTimeline)
  app.component('FPluginHome', FPluginHome)
  app.component('FPluginTable', FPluginTable)
  app.component('FPluginCalendar', FPluginCalendar)
  app.component('FPluginBaList', FPluginBaList)
  app.component('FPluginProduct', FPluginProduct)
  app.component('FPluginTreeTab', FPluginTreeTab)
  app.component('FPluginIndoorMap', FPluginIndoorMap)
  app.component('FPluginIndoorMapshow', FPluginIndoorMapshow)
  app.component('FPluginDevMap', FPluginDevMap)
  // 布局框架
  app.component('FLayout', FLayout)
  // 功能组件
  app.component('FReport', FReport)
  app.component('FSearch', FSearch)
  app.component('FSearchno', FSearchno)
  app.component('FTable', FTable)
  app.component('FDetail', FDetail)
  app.component('FForm', FForm)
  app.component('FIndoorMarker', FIndoorMarker)
  app.component('FUploadImage', FUploadImage)
  app.component('FUploadImages', FUploadImages)
  app.component('FUploadFile', FUploadFile)
  app.component('FTimeline', FTimeline)
  app.component('FCardList', FCardList)
  app.component('FEsign', FEsign)
  app.component('FEsignBm', FEsignBm)
  app.component('FKstime', FKstime)
  app.component('FUploadImageBm', FUploadImageBm)
  // 园区服务通用概览
  app.component('ServiceOverview', ServiceOverview)
}

export default {
  install
}
